import React from "react";
import styled from "styled-components";
import { H3 } from "styleguide/components/Text"

const StyledH3 = styled(H3)`
  padding-left: 0 !important;
`

const ClosingRemark = () => (
  <>
    <StyledH3>Closing Remark</StyledH3>
    <div>
      Could your team use some help with topics like this and others covered by ShakaCode&apos;s blog and open source?
      We specialize in optimizing Rails applications, 
      especially those with advanced JavaScript frontends, like React. 
      We can also help you optimize your CI processes with lower costs and faster, more reliable tests. 
      Scraping web data and lowering infrastructure costs are two other areas of specialization.
      Feel free to reach out to ShakaCode&apos;s CEO, Justin Gordon, at
      <a href="mailto:justin@shakacode.com"> justin@shakacode.com </a> or
      <a href="https://meetings.hubspot.com/justingordon/30-minute-consultation"> schedule an appointment </a> 
      to discuss how ShakaCode can help your project!
    </div>
  </>  
)

export default ClosingRemark
